import IResult from "../../models/result/IResult";
import { sendGet, sendPost, sendPut } from "./generic";
import { MetaConnectAccountRequest } from "../../models/integrations/api/MetaConnectAccountRequest";
import { FacebookSubscribePagesRequest } from "../../models/features/api/Meta/FacebookSusbscribePagesRequest";


//organizationId: voicify org id 
export const connectFacebook = (organizationId: string, accessCode: string): Promise<IResult<any>> => {
    return sendPost<MetaConnectAccountRequest>(`/meta/connect`, { organizationId, accessCode });
}

export const getFacebookPages = (organizationId: string): Promise<IResult<any>> => {
    return sendGet<MetaConnectAccountRequest>(`/meta/pages/${organizationId}`);
}

export const subscribePages = (request: FacebookSubscribePagesRequest): Promise<IResult<any>> => {
    return sendPut<MetaConnectAccountRequest>(`/meta/pages/subscribe`, request);
}

export const disconnectFacebook = (organizationId: string): Promise<IResult<any>> => {
    return sendPost<MetaConnectAccountRequest>(`/meta/disconnect/${organizationId}`, null);
}